"use strict";

const onNextRender = (fn) => setTimeout(fn, 100);

export default onNextRender;
